import styled from "styled-components";

export const UserContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  img {
    height: 10rem;
  }

  h1 {
    ${(props) => `font-family: ${props.theme.fontFamilies.primaryFont};`}
    box-sizing: border-box;
    font-size: 1.7rem;
    font-weight: 600;
    margin-bottom: 0;
    text-align: center;
  }

  h2 {
    ${(props) => `font-family: ${props.theme.fontFamilies.primaryFont};`}
    box-sizing: border-box;
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 0;
    text-align: center;
  }

  h3 {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p30
      };
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 1.3rem;
    font-weight: 500;
    text-align: center;
  }
`;
